import { RoutePath } from '@components/AppRouter/constants';

import { Account } from '../../Account';
import { Audit } from '../../Audit';
import { DataControl } from '../../DataControl';
import { ErrorPage } from '../../ErrorPage';
import { HomePage } from '../../HomePage';
import { Logs } from '../../Logs';
import { PreparationOfReports } from '../../PreparationOfReports';
import { ReportingTree } from '../../ReportingTree';
import { Settings } from '../../Settings';
import { SettingUserRoles } from '../../SettingUserRoles';
import { UserRoleReport } from '../../UserRoleReport';
import { dictionaryConfig } from './routes/dictionaryConfig';
import type { RouteConfig } from '../types';

export const routeConfig: RouteConfig = {
  defaultRoute: RoutePath.HOME,
  routes: [
    {
      path: RoutePath.HOME,
      component: HomePage,
      hidden: true,
    },
    {
      path: RoutePath.ERROR_PAGE,
      component: ErrorPage,
      hidden: true,
    },
    {
      path: RoutePath.PREPARATION_OF_REPORTS,
      component: PreparationOfReports,
      title: 'Реестр подготовки отчетности',
      resourceName: 'CmPublicationRegister',
    },
    {
      path: RoutePath.REPORTING_TREE,
      component: ReportingTree,
      title: 'Просмотр отчетности',
      resourceName: 'CmCompanyReport',
    },
    {
      title: 'Мониторинг фоновых процессов',
      path: RoutePath.LOGS,
      component: Logs,
      resourceName: 'CmEtlProcess',
    },
    {
      title: 'Результаты выполнения КП',
      path: RoutePath.DATA_CONTROL,
      component: DataControl,
      resourceName: 'CmCtrlResults',
    },
    {
      path: RoutePath.ACCOUNT,
      component: Account,
      hidden: true,
      resourceName: 'CmWorkplace',
    },
    {
      path: RoutePath.AUDIT,
      component: Audit,
      resourceName: 'CmAdministration',
    },
    {
      path: RoutePath.USER_ROLE_REPORT,
      component: UserRoleReport,
      resourceName: 'CmAdministration',
    },
    {
      path: RoutePath.SETTING_USER_ROLES,
      component: SettingUserRoles,
      resourceName: 'CmUserDataFilter',
    },
    {
      path: RoutePath.SETTINGS,
      component: Settings,
      resourceName: 'CmSettings',
    },
    { ...dictionaryConfig },
  ],
};
